import { CartsApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from './apiConfigs'

export const cartsClient = new CartsApi(ecomConfiguration)
